// What a Lion Auto number box (components/lionAuto/NumberField) reports for
// its text. Pure; tested in lionAutoNumber.test.js.

/**
 * The number a box's text stands for, or null when it stands for none (the
 * box shows red and keeps reporting its last value). A blank box is a value
 * only when the box is blankable (blankValue set: the floor's blank = use
 * the show's / artist's floor). badInput: the browser's validity.badInput
 * (a type="number" box holding "1e" reads as blank to us), never a value,
 * not even the blank one, so a typo never clears the floor.
 * @param {string} raw  the box's text
 * @param {{ min?: number, max?: number|null, integer?: boolean, blankValue?: number, badInput?: boolean }} [opts]
 * @returns {number|null}
 */
export function parseNumberInput(raw, { min = 0, max = null, integer = false, blankValue, badInput = false } = {}) {
  if (badInput) return null;
  const text = String(raw ?? '');
  if (text.trim() === '') return blankValue !== undefined ? blankValue : null;
  const n = Number(text);
  if (!Number.isFinite(n) || n < min || (max != null && n > max)) return null;
  if (integer && !Number.isInteger(n)) return null;
  return n;
}
